module.exports = __webpack_public_path__ + "static/media/project_7.ab09736c.png";